import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updatePartner } from "services";

import { GET_ALL_PARTNERS, GET_PARTNER, UPDATE_PARTNER } from "consts";

export const useUpdatePartner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPDATE_PARTNER],
    mutationFn: updatePartner,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [GET_ALL_PARTNERS] });
      queryClient.invalidateQueries({ queryKey: [GET_PARTNER, variables.id] });
    },
  });
};
